import { Routes, Route } from 'react-router-dom'
import Main from "../pages/Main/Main";
import List from '../pages/List/List';
import Students from '../pages/Students/Students';
import Teacher from '../pages/Teacher/Teacher';
import Users from '../pages/Users/Users';
import { RequireAuth } from './RequireAuth';
import AddStudent from '../pages/AddStudent/AddStudent';
import Profile from '../pages/Profile/Profile';
import { useAppSelector } from '../redux/hooks';
import { RequireAuthRole } from './RequireAuthRole';
import { AddSubscrip } from '../pages/AddSubscrip/AddSubscrip';
import SignUp from '../pages/SignUp/SignUp';
import { Notice } from '../pages/Notice/Notice';
import SignUpStu from '../pages/SignUpStu/SignUpStu';
import { AddSubscripV2 } from '../pages/AddSubscripV2/AddSubscripV2';
import { NoticeInfo } from '../pages/NoticeInfo/NoticeInfo';
import { NoticeInfoAdmin } from '../pages/NoticeInfoAdmin/NoticeInfoAdmin';
import { NoticeStudent } from '../pages/NoticeStudent/NoticeStudent';
import Politik from '../pages/Politik/Politik';

const AppRouter = () => {
    const role = useAppSelector((state) => state.usersR.user.role)

    return (
        <Routes>
            <Route path="/" element={<Main />} />

            <Route path="/sign-up" element={
                <RequireAuthRole role={role}>
                    <SignUp />
                </RequireAuthRole>
            } />

            <Route path="/sign-up-stu" element={
                <SignUpStu />
            } />

            <Route path="/politik" element={
                <Politik />
            } />

            <Route path="/add-students" element={
                <RequireAuthRole role={role}>
                    <AddStudent />
                </RequireAuthRole>
            } />
            <Route path="/teacher" element={
                <RequireAuthRole role={role}>
                    <Teacher />
                </RequireAuthRole>
            } />
            <Route path="/list" element={
                <RequireAuthRole role={role}>
                    <List />
                </RequireAuthRole>
            } />
            <Route path="/students" element={
                <RequireAuthRole role={role}>
                    <Students />
                </RequireAuthRole>
            } />
            <Route path="/users" element={
                <RequireAuthRole role={role}>
                    <Users />
                </RequireAuthRole>
            } />
            <Route path="/office" element={
                <RequireAuth>
                    <Profile />
                </RequireAuth>
            } />
            <Route path="/subscrip" element={
                <RequireAuthRole role={role}>
                    <AddSubscrip />
                </RequireAuthRole>
            } />
            <Route path="/subscripV2" element={
                <RequireAuthRole role={role}>
                    <AddSubscripV2 />
                </RequireAuthRole>
            } />
            <Route path="/notice-info" element={
                <RequireAuthRole role={role}>
                    <NoticeInfo />
                </RequireAuthRole>
            } />
            <Route path="/notice-info-admin" element={
                <RequireAuthRole role={role}>
                    <NoticeInfoAdmin />
                </RequireAuthRole>
            } />
            <Route path="/notice-student" element={
                <RequireAuthRole role={role}>
                    <NoticeStudent />
                </RequireAuthRole>
            } />
            <Route path="/notice" element={
                <RequireAuthRole role={role}>
                    <Notice />
                </RequireAuthRole>
            } />
        </Routes>
    );
};


export default AppRouter;
